import React, { useState, useEffect } from 'react';
import {
  View, Text, Alert, Image, StyleSheet,
} from 'react-native';
import { useMutation } from '@apollo/client';
import {
  Button, Dialog, Portal, TextInput, Menu, TouchableRipple,
} from 'react-native-paper';
import * as ImagePicker from 'expo-image-picker';
import { UPDATE_EQUIPMENT_ON_BAG } from '../../gql/equipment/mutation';
import QualityGradeInfo, { qualityGrades } from '../../components/commons/QualityGradeInfo';

const styles = StyleSheet.create({
  imageContainer: {
    alignItems: 'center',
    marginVertical: 20,
  },
  image: {
    width: 150,
    height: 150,
  },
  imageButtons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 10,
  },
  menuAnchor: {
    padding: 10,
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    marginTop: 10,
  },
  formInput: {
    marginBottom: 15,
  },
  qualityGradeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

function EquipmentOnBagDialog({
  visible, onDismiss, equipmentOnBag, refetch,
}) {
  const [comments, setComments] = useState('');
  const [qualityGrade, setQualityGrade] = useState('');
  const [picture, setPicture] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);

  const [updateEquipmentOnBag] = useMutation(UPDATE_EQUIPMENT_ON_BAG);

  useEffect(() => {
    if (equipmentOnBag) {
      setComments(equipmentOnBag.comments || '');
      setQualityGrade(equipmentOnBag.qualityGrade || '');
      setPicture(equipmentOnBag.picture ? { uri: `data:image/jpeg;base64,${equipmentOnBag.picture}` } : null);
    }
  }, [equipmentOnBag]);

  const handleUpdate = async () => {
    console.log('handleUpdate called');
    try {
      let pictureBase64 = null;
      if (picture && picture.uri.startsWith('data:image')) {
        pictureBase64 = picture.uri.split(',')[1];
      } else if (picture) {
        pictureBase64 = picture.uri;
      }

      console.log('Variables for updateEquipmentOnBag:', {
        bagId: equipmentOnBag.bag.id,
        equipmentId: equipmentOnBag.equipment.id,
        comments: comments === '' ? null : comments,
        qualityGrade: qualityGrade === '' ? null : qualityGrade,
        picture: pictureBase64 === null ? null : pictureBase64,
      });

      const { data } = await updateEquipmentOnBag({
        variables: {
          bagId: equipmentOnBag.bag.id,
          equipmentId: equipmentOnBag.equipment.id,
          comments: comments === '' ? null : comments,
          qualityGrade: qualityGrade === '' ? null : qualityGrade,
          picture: pictureBase64 === null ? null : pictureBase64,
        },
      });
      console.log('Mutation response:', data);
      refetch();
      onDismiss();
    } catch (e) {
      console.error('Error updating equipment on bag:', e);
      Alert.alert('Error', e.message);
    }
  };

  const handleChoosePhoto = async () => {
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
      base64: true,
    });
    if (!result.canceled) {
      setPicture({ uri: `data:${result.assets[0].mimeType};base64,${result.assets[0].base64}` });
    }
  };

  const handleTakePhoto = async () => {
    const result = await ImagePicker.launchCameraAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
      base64: true,
    });
    if (!result.canceled) {
      setPicture({ uri: `data:${result.assets[0].mimeType};base64,${result.assets[0].base64}` });
    }
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss}>
        <Dialog.Title>Modifier l'équipement</Dialog.Title>
        <Dialog.Content>
          <View style={styles.formInput}>
            <View style={styles.qualityGradeContainer}>
              <Text>Qualité</Text>
              <QualityGradeInfo />
            </View>
            <Menu
              visible={menuVisible}
              onDismiss={() => setMenuVisible(false)}
              anchor={(
                <TouchableRipple onPress={() => setMenuVisible(true)}>
                  <View style={styles.menuAnchor}>
                    <Text>{qualityGrade ? `${qualityGrade} - ${qualityGrades[qualityGrade]}` : 'Sélectionner une qualité'}</Text>
                  </View>
                </TouchableRipple>
              )}
            >
              {Object.keys(qualityGrades).map((grade) => (
                <Menu.Item
                  key={grade}
                  onPress={() => {
                    setQualityGrade(grade);
                    setMenuVisible(false);
                  }}
                  title={`${grade} - ${qualityGrades[grade]}`}
                />
              ))}
            </Menu>
          </View>

          <View style={[styles.formInput]}>
            <Text>Photo</Text>
            <View style={styles.imageContainer}>
              <Image
                source={picture || require('../../assets/logo.png')}
                style={styles.image}
              />
              <View style={styles.imageButtons}>
                <Button icon="image-album" onPress={handleChoosePhoto}>Galerie</Button>
                <Button icon="camera" onPress={handleTakePhoto}>Appareil photo</Button>
              </View>
            </View>
          </View>

          <View style={styles.formInput}>
            <TextInput
              label="Commentaires"
              value={comments}
              onChangeText={setComments}
              multiline
              numberOfLines={4}
            />
          </View>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDismiss}>Annuler</Button>
          <Button onPress={handleUpdate}>Mettre à jour</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
}

export default EquipmentOnBagDialog;
